import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="problem_amj p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className=" my-auto">
            <h2>The Solution</h2>
            <p>
              Tekrevol’s business analysts and technical team created an
              advanced mobile application with separate panels, features, and
              functionalities. The aspects of the apps were integrated to help
              different user segments:
            </p>
            <p>Here are the top 5 benefits the HDE app offers:</p>
            <ul className="ul_sytle">
              <li>
                Presenting video catalogs for accurate representation of
                products.
              </li>
              <li>Effective auction management.</li>
              <li>Convenient payment options.</li>
              <li>Allowed users to edit their videos.</li>
              <li>Custom signup packages for different sizes of businesses.</li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 text-center my-auto resp_order"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/hde/Tek_img_02.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={846}
                height={708}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
